import { Module, Mutation, VuexModule } from 'vuex-module-decorators'
import store from '..'


@Module({ namespaced: true })
export default class GenericFormModule extends VuexModule {
  isOpen = false
  form = []

  @Mutation
  open(formItem: any): void {
    this.isOpen = true

    this.form = formItem
    // use the content overlay onclick function
    store.commit('openContentOverlay', () => store.commit('genericForm/close'))
  }

  @Mutation
  close(): void {
    this.isOpen = false
    store.commit('closeContentOverlay', false)
    store.commit("requestDownload/close")
  }
}
